module.exports = __webpack_public_path__ + "img/ico-add-new.c971c701.svg";